import { render } from "./suggestive-search.vue?vue&type=template&id=5ea906e1"
import script from "./suggestive-search.vue?vue&type=script&lang=js"
export * from "./suggestive-search.vue?vue&type=script&lang=js"

import exportComponent from "/Users/drewcarrette/Sites/trauma/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__